import { ItemListPosition, truncateString, useIntl } from '@capsicum/common';
import { Button, env, InfoCard } from '@capsicum/common-web';
import { ChilizChainCircleIcon, ExternalLinkIcon } from '@capsicum/common-web/icons';
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';

const chainTokenBaseUrl = env.NEXT_PUBLIC_CHILISCAN_URL + '/token/';

type NCWalletCurrencyPageProps = {
	isPending: boolean;
	smartContractAddress?: string;
};

export const NCWalletCurrencyPage = ({ isPending, smartContractAddress }: NCWalletCurrencyPageProps) => {
	const { $t } = useIntl();

	const onClickChainAddress = useCallback(() => {
		const link = `${chainTokenBaseUrl}${smartContractAddress}`;

		window.open(link, '_blank');
	}, [smartContractAddress]);

	const marginRighComponent = useMemo(() => {
		return smartContractAddress ? (
			<S.HashButton
				buttonElementStyle={{ padding: 0 }}
				iconEnd={{ icon: { iconSize: 'medium', src: ExternalLinkIcon } }}
				testID="currenyPage-chainExplorer-link"
				text={truncateString(smartContractAddress, 8, 8)}
				variant="text"
				onClick={onClickChainAddress}
			/>
		) : (
			'--'
		);
	}, [smartContractAddress]);

	return (
		<S.CurrencyPageWrapper>
			<S.CurrencyTitle>{$t('ncCurrency.title')}</S.CurrencyTitle>
			<InfoCard
				IconLeft={ChilizChainCircleIcon}
				isLoading={isPending}
				itemListPosition={ItemListPosition.SOLO}
				mainRightText={marginRighComponent}
				testID="currency-page-info-card-smart-contract-address"
				title={$t('ncCurrency.heading')}
			/>
		</S.CurrencyPageWrapper>
	);
};

namespace S {
	export const CurrencyPageWrapper = styled.div`
		display: flex;
		width: 100%;
		flex-direction: column;
		padding: ${({ theme }) => `${theme.sizing.large} ${theme.sizing.xsmall}`};

		${({ theme }) => theme.breakpoints.queries.above.tabletSmallDesktop} {
			padding: ${({ theme }) => `${theme.sizing.large} 0`};
		}
	`;

	export const CurrencyTitle = styled.p`
		${({ theme }) => theme.fonts.headings.title5};
		margin: 0;
		padding-bottom: ${({ theme }) => theme.sizing.xsmall};
	`;

	export const HashButton = styled(Button)`
		height: 27px;
	`;
}
